import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { getApplicationById } from "../../../api/apiServices";
import { useQuery } from 'react-query';

const ViewApplication = (props) => {
    useEffect(() => {
        // 👇️ scroll to top on page load
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    });
    const params = useParams();
    const id = parseInt(params.id)

    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/regional_approvals";

    const {
        isLoading,
        isError,
        error,
        data: applicant
    } = useQuery(['applicant', id], () => getApplicationById(id));

    let content
    if (isLoading) {
        content = <p>Loading...</p>
    } else if (isError) {
        content = <p>{error.message}</p>
    } else {
        content = (
            <>
                <div className="profile-picture">
                    <img src={`/images/members/${applicant?.profile_picture}`} className="image" alt="" />
                </div>
                <div className="table-responsive lg">
                    <table className="table table-borderless">
                        <tbody>
                            <tr>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>PF Number</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "no-wrap" }}> :	{applicant.pf_number}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>NDC Number</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.ndc_applicantship_number}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>VoterID Number</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.voter_id_number}</td>
                            </tr>
                            <tr>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>LastName</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.last_name}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>FirstName</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.first_name}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>MiddleName</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.middle_name}</td>
                            </tr>
                            <tr>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Date of Birth</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.date_of_birth}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Gender</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.gender}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Marital setMaritalStatus</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.marital_status}</td>
                            </tr>
                            <tr>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Mobile Number</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.mobile_number}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Email Address</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.email}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Date Joined</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.date_joined}</td>
                            </tr>
                            <tr>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Region</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.region}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Constituency</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.constituency}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Branch</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.branch}</td>
                            </tr>
                            <tr>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Qualifications</td>
                                <td colSpan="3" style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.qualification}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Profession</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.profession}</td>
                            </tr>
                            <tr>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Occupations</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.occupations}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Employment Type</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant?.employment_type}</td>
                                <td style={{ fontSize: "16px", fontWeight: "700", color: "#000b41", align: "left" }}>Current Employment</td>
                                <td style={{ fontSize: "14px", fontWeight: "500", textAlign: "left", whiteSpace: "pre-wrap" }}> :	{applicant.current_employment}</td>
                            </tr>
                            <tr>
                                <td colSpan={3}>
                                    <strong style={{ fontSize: "18px", fontWeight: "700", color: "brown" }}><a rel="noreferrer" target="_blank" href="https://www.ndcpayment.com/dues/pay">Click to verify applicant NDC membership status</a></strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </>
        );
    }

    return (
        <>
            <section className="content-header">
                <h1>View Application</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            Application Details
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-body">
                                {content}
                            </div>
                            <div className="panel-footer">
                                <form>
                                    <div className="form-group row">
                                        <div className="col-sm-2">
                                            <button type="submit" className="btn btn-danger btn-block" onClick={() => navigate(from, { replace: true })}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ViewApplication;


